import { Button, Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { getContrastTextColor } from "../../utils/color";

interface PublicRaffleCardProps {
  raffle: IRaffle;
  href: string;
  primaryColor: string;
}

export const PublicRaffleCard = ({ raffle, href, primaryColor }: PublicRaffleCardProps) => {
  const navigate = useNavigate();

  const awards = [...(raffle.awards || [])].sort((a, b) => a.order - b.order);
  const image = awards.flatMap((award) => award.images)[0];

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 360,
        borderRadius: 4,
        boxShadow: 6,
        overflow: "hidden",
        backgroundColor: "#121212",
        color: "#fff",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: 12,
        },
      }}
    >
      <CardActionArea onClick={() => navigate(href)}>
        {image && (
          <CardMedia
            component="img"
            height="220"
            image={image}
            alt={raffle.name}
            sx={{ objectFit: "cover" }}
          />
        )}
        <CardContent>
          <Typography gutterBottom variant="h6" fontWeight="bold" fontFamily="Phrastic">
            {raffle.name}
          </Typography>
          {awards.map((award) => (
            <Typography key={`${award.order}-${award.name}`} variant="body2" sx={{ color: "grey.400" }}>
              🏆 {award.name}
            </Typography>
          ))}
          <Button
            component="span"
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              fontWeight: "bold",
              backgroundColor: primaryColor,
              color: getContrastTextColor(primaryColor),
              "&:hover": { backgroundColor: primaryColor, opacity: 0.9 },
            }}
          >
            Participar
          </Button>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
